<template>
    <div>
        <!--Start Middle content-->
        <!--Start internal page banner section-->
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> Benefits 
                            <div v-if="role.id <= 1" class="col-12 col-sm-12 col-md-3 col-lg-2 pull-right">
                                <v-select v-model="locationType"
                                          name="locationType"
                                          id="locationType"
                                          label="text"
                                          :clearable="false"
                                          :searchable="false"
                                          :filterable="false"
                                          :options="locationTypeArr"
                                          placeholder="Select Location Type">
                                </v-select>
                            </div>
                            <!-- <div v-if="role.id <= 1" class="col-12 col-sm-12 col-md-3 col-lg-2 pull-right">
                                <v-select class=""
                                          v-model="locationId"
                                          name="locationId"
                                          id="locationData"
                                          label="text"
                                          :clearable="false"
                                          :searchable="false"
                                          :filterable="false"
                                          :options="locationArr"
                                          placeholder="Select State">
                                </v-select>
                            </div> -->
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->

        <div class="internal-page-main-section benifit-section-main col-12">
            <div class="container">
                <div class="row">
                    <app-slider :sliderType='sliderType' :key='sliderType.location_type'></app-slider>

                    <div class="benifit-section-main col-12 float-l">
                        <div class="row">
                            <div class="benifit-section-left col-12 col-sm-4 col-md-4 col-lg-4 float-l">
                                <!--left side-->
                                <div class="row">
                                    <h2 class="color-white heading-text-25 line-height-28 bg-color-red pt-15 pb-15 pl-30 pr-30 ucase font-text-bold-mont float-l width-full mb-0"> {{ locationType.text }} Benefits </h2>

                                    <div class="bottom-benifit-left bg-color-e1e8ee width-full float-l">
                                        <template v-for="(text, index) in benefitList">
                                            <div class="benifit-detail-bt float-l width-full mt-40">
                                                <!--first-->
                                                <h4>{{text.type_name}}-{{text.provider_name}}</h4>

                                                <p class="benifit-call-no" v-html="text.phone"></p>

                                                <p class="benifit-grup-name"> {{text.group}} </p>

                                                <span v-html="text.url" v-linkified:options="{ className: 'benifit-website' }"/>
                                            </div>
                                        </template>
                                        <!--first-->

                                        <!--<div class="benifit-detail-bt float-l width-full mt-60">-->
                                        <!--&lt;!&ndash;second&ndash;&gt;-->
                                        <!--<h4> Dental - Metlife </h4>-->

                                        <!--<p class="benifit-call-no"> 800-438-6388 </p>-->

                                        <!--<p class="benifit-grup-name"> Group #5925614 </p>-->

                                        <!--<a class="benifit-website" href="https://www.metlife.com/" target="_blank"> www.metlife.com/my benefits </a>-->
                                        <!--</div>-->
                                        <!--&lt;!&ndash;second&ndash;&gt;-->

                                        <!--<div class="benifit-detail-bt float-l width-full mt-60">-->
                                        <!--&lt;!&ndash;third&ndash;&gt;-->
                                        <!--<h4> Vision - MES </h4>-->

                                        <!--<p class="benifit-call-no"> 800-877-6372 </p>-->

                                        <!--<p class="benifit-grup-name"> Group #13597 </p>-->

                                        <!--<a class="benifit-website" href="https://www.mesvision.com/homepage.htm" target="_blank"> www.MESVision.com </a>-->
                                        <!--</div>-->
                                        <!--&lt;!&ndash;third&ndash;&gt;-->

                                        <!--<div class="benifit-detail-bt float-l width-full mt-60">-->
                                        <!--&lt;!&ndash;forth&ndash;&gt;-->
                                        <!--<h4> 401 - K - TransAmerica </h4>-->

                                        <!--<p class="benifit-call-no">800-401-8726 </p>-->

                                        <!--<a class="benifit-website" href="https://www.ta-retirement.com/" target="_blank"> www.TA-Retirement.com </a>-->
                                        <!--</div>-->
                                        <!--forth-->

                                    </div>

                                </div>
                            </div>
                            <!--left side-->

                            <div class="benifit-section-right col-12 col-sm-8 col-md-8 col-lg-8 float-l">
                                <!--right side-->
                                <img class="benifit-arrow-img" src="/static/images/benifit-arrow.png">
                                <div class="row">
                                    <p class="benifit-sec-para color-333333 heading-text-16 line-height-22 float-l width-full font-text-semi-medium-mont border-bottom-dddddd pb-55"> The Company provides comprehensive <span class="font-text-bold-mont"> medical, dental and vision plans </span> for eligible employees and their dependents on the first day of the month following 30 days of employment. Eligible
                                        employees are employees working 30 hours or more per week. </p>

                                    <div class="bottom-right-brnifit-list float-l width-full">
                                        <!--points-->
                                        <h2 class="color-333333 heading-text-25 line-height-28 font-text-semi-medium-mont"> How to Enroll </h2>

                                        <ul>
                                            <li>
                                                <p class="benifit-enroll-no"> 1 </p>
                                                <p class="mt-8 color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l colpie-40 pl-20"> Review your coverage options: </p>

                                                <div class="view-right-benifit-r float-l width-full">
                                                    <template v-for="(text, index) in sites">
                                                        <div class="view-btn-small-big benifit-btn float-l">
                                                            <a :href="text.site_url" class="hvr-sweep-to-right-blue" target="_blank"> <i class="hi-icon icon_1language"> </i> Benefits Website </a>
                                                        </div>
                                                    </template>
                                                    <template v-for="(text, index) in benefitGlance">
                                                        <div class="view-btn-small-big benifit-btn float-l">
                                                                <template v-if="text.upload_type == 'url'">
                                                                    <a :href="text.doc_path" class="hvr-sweep-to-right-blue" target="_blank"> 
                                                                    <i class="hi-icon icon_1language"> </i>
                                                                    {{text.button_title}} </a>
                                                                </template>
                                                                <template v-else>
                                                                    <a href="#" class="hvr-sweep-to-right-blue" @click="getSignedUrlPath(text.doc_path)"> 
                                                                    <i class="hi-icon icon_1download-arrow"> </i>
                                                                    {{text.button_title}} </a>
                                                                </template>
                                                            <!-- <a :href="text.doc_path" class="hvr-sweep-to-right-blue" target="_blank"> 
                                                                <template v-if="text.upload_type == 'url'">
                                                                    <i class="hi-icon icon_1language"> </i>
                                                                </template>
                                                                <template v-else>
                                                                    <i class="hi-icon icon_1download-arrow"> </i>
                                                                </template>
                                                                {{text.button_title}} </a> -->
                                                        </div>
                                                    </template>
                                                    <!--<template v-if="country == 'AZ'">
                                                        <div class="view-btn-small-big benifit-btn float-l">
                                                            <a href="/static/pdf/Arizona 2019-Enrollment Guide.pdf" class="hvr-sweep-to-right-blue" target="_blank"> <i class="hi-icon icon_1download-arrow"> </i> Benefit at a Glance – Non-Banner </a>
                                                        </div>
                                                        <div class="view-btn-small-big benifit-btn float-l">
                                                            <a href="/static/pdf/Arizona Banner 2019-EnrollmentGuide.pdf" class="hvr-sweep-to-right-blue" target="_blank"> <i class="hi-icon icon_1download-arrow"> </i> Benefit at a Glance-Banner </a>
                                                        </div>
                                                    </template>
                                                    <template v-else-if="country == 'CA'">
                                                        <div class="view-btn-small-big benifit-btn float-l">
                                                            <a href="/static/pdf/California 2019 Enrollment Guide.pdf" class="hvr-sweep-to-right-blue" target="_blank"> <i class="hi-icon icon_1download-arrow"> </i> Benefits at a Glance </a>
                                                        </div>
                                                    </template>
                                                    <template v-else-if="country == 'NV'">
                                                        <div class="view-btn-small-big benifit-btn float-l">
                                                            <a href="/static/pdf/Nevada 2019 Enrollment Guide.pdf" class="hvr-sweep-to-right-blue" target="_blank"> <i class="hi-icon icon_1download-arrow"> </i> Benefits at a Glance </a>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="view-btn-small-big benifit-btn float-l">
                                                            <a href="/static/pdf/Other 2019 Enrollment Guide.pdf" class="hvr-sweep-to-right-blue" target="_blank"> <i class="hi-icon icon_1download-arrow"> </i> Benefit at a Glance – Non-Banner </a>
                                                        </div>
                                                    </template>-->
                                                </div>
                                                <!--<div class="view-right-benifit-r float-l colpie-53">
                                                    <div class="view-btn-small-big benifit-btn float-r">
                                                        <template v-if="country == 'AZ'">
                                                            <div class="row">
                                                                <a href="/static/pdf/Arizona 2019-Enrollment Guide.pdf" class="hvr-sweep-to-right-blue" onclick="window.open('/static/pdf/Arizona Banner 2019-EnrollmentGuide.pdf');" target="_blank"> Benefits at a Glance </a>
                                                            </div>    
                                                        </template>
                                                        <template v-else-if="country == 'CA'">
                                                            <div class="row">
                                                                <a href="/static/pdf/California 2019 Enrollment Guide.pdf" class="hvr-sweep-to-right-blue" target="_blank"> Benefits at a Glance </a>
                                                            </div>    
                                                        </template>
                                                        <template v-else-if="country == 'NV'">
                                                            <div class="row">
                                                                <a href="/static/pdf/Nevada 2019 Enrollment Guide.pdf" class="hvr-sweep-to-right-blue" target="_blank"> Benefits at a Glance </a>
                                                            </div>    
                                                        </template>
                                                        <template v-else>
                                                            <div class="row">
                                                                <a href="/static/pdf/Other 2019 Enrollment Guide.pdf" class="hvr-sweep-to-right-blue" target="_blank"> Benefits at a Glance </a>
                                                            </div>    
                                                        </template>
                                                    </div>
                                                    <template v-for="(text, index) in sites">
                                                        <div class="view-btn-small-big benifit-btn benifit-btn-right float-r mt-10">
                                                            <div class="row">
                                                                <a :href="text.site_url" class="hvr-sweep-to-right-blue" target="_blank"> Benefits Website </a>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>-->
                                                <!--<p class="benifit-enroll-no"> 1 </p>

                                                <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l colpie-45 pl-20"> 1. Review your coverage options: </p>

                                                <div class="view-btn-small-big benifit-btn-v float-r colpie-55">
                                                    <a href="" class="hvr-sweep-to-right-blue float-r" > Benefits at a Glance </a>
                                                    <a href="" class="hvr-sweep-to-right-blue float-r" > Benefits Website </a>
                                                </div>-->

                                            </li>

                                            <li>
                                                <p class="benifit-enroll-no"> 2 </p>
                                                <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont pl-22 pt-10 colpie-92 float-l"> Have dates of birth and Social Security numbers for any dependents you plan to enroll </p>
                                            </li>

                                            <li>
                                                <p class="benifit-enroll-no"> 3 </p>

                                                <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l colpie-45 pl-20"> Log onto the dayforce website and go to the benefits section to make your enrollment elections. </p>

                                                <div class="view-btn-small-big benifit-btn-v float-r colpie-55">
                                                    <a href="https://www.dayforcehcm.com/mydayforce/login.aspx" class="hvr-sweep-to-right-blue float-r" target="_blank"> Log onto the Dayforce Website </a>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                    <!--points-->

                                    <div class="video-section col-12 float-l">
                                        <!--video section-->
                                        <div class="row">

                                            <div class="row">
                                                <template v-if="video.length > 0">
                                                    <ul class="float-l width-full">
                                                        <li>
                                                            <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont pl-16 colpie-92 float-l width-full"> To Learn More About The Benefits We Offer, Please Watch Video Below</p>
                                                        </li>
                                                    </ul>
                                                    <template v-for="(video_data, index) in video">
                                                        <div class="pt-20 ca-video-detail col-12 col-sm-4 col-md-4 col-lg-4">
                                                            <!--video 1 -->
                                                            <div class="video-popup">
                                                                <!--<button type="button" id="openModel" data-toggle="modal" :data-target="'#' + video_data.id + '_myModal'"><img src="/static/images/video-section-1.jpg" alt="Corresponding benefits"></button>-->
                                                                <a :href="'#' + video_data.id + '_myModal'" data-toggle="modal" v-on:click="openModelFunction(video_data.id)"> <img src="/static/images/video-section-1.jpg" alt="Corresponding benefits"> </a>
                                                            </div>

                                                            <!-- Video Modal -->
                                                            <div class="modal fade" :id="video_data.id + '_myModal'" role="dialog" >
                                                                <div class="modal-dialog">
                                                                    <div class="modal-content">
                                                                        <div class="modal-header">
                                                                            <h4 class="modal-title">Corresponding benefits</h4>
                                                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                                                        </div>
                                                                        <div class="modal-body">
                                                                            <iframe id="hrbenifit" width="466" height="315" :src="video_data.video_url+'?autopause=0'" frameborder="0" allowfullscreen></iframe>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- Video Modal -->
                                                        </div>
                                                    </template>
                                                </template>
                                                <!--video 1 -->

                                                <!--<div class="ca-video-detail col-12 col-sm-4 col-md-4 col-lg-4">-->
                                                <!--&lt;!&ndash;video 1 &ndash;&gt;-->
                                                <!--<div class="video-popup">-->
                                                <!--<a href="#myModal" data-toggle="modal"> <img src="/static/images/video-section-2.jpg" alt="Corresponding benefits"> </a>-->
                                                <!--</div>-->

                                                <!--&lt;!&ndash; Video Modal &ndash;&gt;-->
                                                <!--<div id="myModal" class="modal fade">-->
                                                <!--<div class="modal-dialog">-->
                                                <!--<div class="modal-content">-->
                                                <!--<div class="modal-header">-->
                                                <!--<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>-->
                                                <!--<h4 class="modal-title">Corresponding benefits</h4>-->
                                                <!--</div>-->
                                                <!--<div class="modal-body">-->
                                                <!--&lt;!&ndash; <iframe id="hrbenifit" width="560" height="315" src="https://www.brainshark.com/pacificseries/vu?pi=zGqzS9FcgzPl5Sz0&nodesktopflash=1" frameborder="0" allowfullscreen></iframe> &ndash;&gt;-->
                                                <!--</div>-->
                                                <!--</div>-->
                                                <!--</div>-->
                                                <!--</div>-->
                                                <!--&lt;!&ndash; Video Modal &ndash;&gt;-->
                                                <!--</div>-->
                                                <!--video 1 -->

                                                <!--<div class="ca-video-detail col-12 col-sm-4 col-md-4 col-lg-4">-->
                                                <!--&lt;!&ndash;video 1 &ndash;&gt;-->
                                                <!--<div class="video-popup">-->
                                                <!--<a href="#myModal" data-toggle="modal"> <img src="/static/images/video-section-3.jpg" alt="Corresponding benefits"> </a>-->
                                                <!--</div>-->

                                                <!--&lt;!&ndash; Video Modal &ndash;&gt;-->
                                                <!--<div id="myModal" class="modal fade">-->
                                                <!--<div class="modal-dialog">-->
                                                <!--<div class="modal-content">-->
                                                <!--<div class="modal-header">-->
                                                <!--<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>-->
                                                <!--<h4 class="modal-title">Corresponding benefits</h4>-->
                                                <!--</div>-->
                                                <!--<div class="modal-body">-->
                                                <!--&lt;!&ndash; <iframe id="hrbenifit" width="560" height="315" src="https://www.brainshark.com/pacificseries/vu?pi=zGlz4Scw6zPl5Sz0&nodesktopflash=1" frameborder="0" allowfullscreen></iframe> &ndash;&gt;-->
                                                <!--</div>-->
                                                <!--</div>-->
                                                <!--</div>-->
                                                <!--</div>-->
                                                <!--&lt;!&ndash; Video Modal &ndash;&gt;-->
                                                <!--</div>-->
                                                <!--video 1 -->
                                            </div>
                                        </div>
                                        <template v-for="(communication, index) in communications">
                                            <div :key="'communication' + index" class="bottom-benifit-para width-full float-l communication">
                                                <div class="row">
                                                    <div class="ca-video-detail col-12 col-sm-12 col-md-8 col-lg-8">
                                                        <!-- video 1 -->
                                                        <div class="video-popup mb-3">
                                                            <img :src="communication.banner_url" alt="Corresponding benefits">
                                                        </div>
                                                    </div>
                                                    <div class="ca-video-detail col-12 col-sm-12 col-md-4 col-lg-4">
                                                        <div class="view-btn-small-big benifit-btn float-l">
                                                            <template v-if="communication.is_flyer_doc == 1">
                                                                <a v-show="communication.flyer_url !=''" href="#" :id="'flyerid' + index" class="hvr-sweep-to-right-blue" @click="getSignedUrlPath(communication.flyer_url)"> {{communication.flyer_label}} </a>
                                                            </template>
                                                            <template v-else>
                                                                <a v-show="communication.flyer_url !=''" :href="communication.flyer_url" class="hvr-sweep-to-right-blue" target="_blank"> {{communication.flyer_label}} </a>
                                                            </template>
                                                            <template v-if="communication.is_pamphlet_doc == 1">
                                                                <a v-show="communication.pamphlet_url !=''" href="#" :id="'pamphletid' + index" class="hvr-sweep-to-right-blue" @click="getSignedUrlPath(communication.pamphlet_url)"> {{communication.pamphlet_label}} </a>
                                                            </template>
                                                            <template v-else>
                                                                <a v-show="communication.pamphlet_url !=''" :href="communication.pamphlet_url" class="hvr-sweep-to-right-blue" target="_blank"> {{communication.pamphlet_label}} </a>
                                                            </template>
                                                            <template v-if="communication.is_ability_doc == 1">
                                                                <a v-show="communication.ability_url !=''" href="#" :id="'abilityid' + index" class="hvr-sweep-to-right-blue" @click="getSignedUrlPath(communication.ability_url)"> {{communication.ability_label}} </a>
                                                            </template>
                                                            <template v-else>
                                                                <a v-show="communication.ability_url !=''" :href="communication.ability_url" class="hvr-sweep-to-right-blue" target="_blank"> {{communication.ability_label}} </a>
                                                            </template>
                                                            <!-- <a v-show="communication.flyer_url !=''" :href="communication.flyer_url" class="hvr-sweep-to-right-blue" target="_blank"> {{communication.flyer_label}} </a>
                                                            <a v-show="communication.pamphlet_url !=''" :href="communication.pamphlet_url" class="hvr-sweep-to-right-blue" target="_blank"> {{communication.pamphlet_label}} </a>
                                                            <a v-show="communication.ability_url !=''" :href="communication.ability_url" class="hvr-sweep-to-right-blue" target="_blank"> {{communication.ability_label}} </a> -->
                                                        </div>
                                                    </div>
                                                </div>
                                                <p v-html="communication.description" v-linkified:options="{ className: 'color-333333 heading-text-14 line-height-20 font-text-semi-medium-mont float-l width-full mt-70' }"/>
                                                <template v-if="communication.tallfree_no != ''">
                                                    <p class="toll-free-call color-333333 heading-text-20 line-height-24 font-text-semi-medium-mont mt-45 float-l width-full"> Call <span class="color-red font-text-bold-mont"> {{mobilenumber(mobilenumber(communication.tallfree_no,3,'-'),7,'-')}} </span> </p>
                                                    <p class="mb-3 color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l width-full mt-1"> Toll Free 24/7 access to EAP. </p>
                                                </template>
                                            </div>
                                        </template>
                                    </div>
                                    <template v-for="(support, index) in supports">
                                        <div class="bottom-benifit-para width-full float-l">
                                            <div class="row">
                                                <div class="ca-video-detail col-12 col-sm-12 col-md-8 col-lg-8">
                                                    <!--video 1 -->
                                                    <div class="video-popup mb-3">
                                                        <img :src="support.banner_url" alt="Corresponding benefits"> </a>
                                                    </div>
                                                </div>
                                                <div class="ca-video-detail col-12 col-sm-12 col-md-4 col-lg-4">
                                                    <div class="view-btn-small-big benifit-btn float-l">
                                                        <a v-show="support.flyer_url !=''" href="#" class="hvr-sweep-to-right-blue" @click="getSignedUrlPath(support.flyer_url)"> {{support.flyer_label}} </a>
                                                        <a v-show="support.pamphlet_url !=''" href="#" class="hvr-sweep-to-right-blue" @click="getSignedUrlPath(support.pamphlet_url)"> {{support.pamphlet_label}} </a>
                                                        <!-- <a v-show="support.flyer_url !=''" :href="support.flyer_url" class="hvr-sweep-to-right-blue" target="_blank"> {{support.flyer_label}} </a>
                                                        <a v-show="support.pamphlet_url !=''" :href="support.pamphlet_url" class="hvr-sweep-to-right-blue" target="_blank"> {{support.pamphlet_label}} </a> -->
                                                    </div>
                                                </div>
                                            </div>
                                            <p v-html="support.description" v-linkified:options="{ className: 'color-333333 heading-text-14 line-height-20 font-text-semi-medium-mont float-l width-full mt-70' }"/>
                                            <template v-if="support.tallfree_no != ''">
                                                <p class="toll-free-call color-333333 heading-text-20 line-height-24 font-text-semi-medium-mont mt-45 float-l width-full"> Call <span class="color-red font-text-bold-mont"> {{mobilenumber(mobilenumber(support.tallfree_no,3,'-'),7,'-')}} </span> </p>
                                                <p class="mb-3 color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l width-full mt-1"> Toll Free 24/7 access to EAP. </p>
                                            </template>
                                        </div>                                        
                                    </template>
                                </div>
                            </div>
                            <!--right side-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--End Middle content-->
    </div>
</template>
<script>
    import Vue from "vue";
    import { HTTP } from '../http-common';
    import vSelect from 'vue-select';
    import SessioMixin from '../mixins/sessionmixin';
    import SliderComponent from "@/components/SliderComponent";
    var self;
    export default {
        name: 'benefits',
        components: {
            'v-select': vSelect,
            'app-slider': SliderComponent,
        },
        mixins: [SessioMixin],
        data() {
            return {
                locationType: {value: 'other', text: 'VVG'},
                locationTypeArr: [
                    {value: 'other', text: 'VVG'},
                    {value: 'Velocity SBA', text: 'Velocity SBA'}
                ],
                sliderType: {
                    type: 'benefit',
                    location_type: 'other',
                },
                roleId: 0,
                roleArr: [],
                country: '',
                video: '',
                sites: '',
                supports: [],
                communications: [],
                benefitList: [],
                benefitGlance: [],

                locationData: '',
                locationArr: [],
                locationId: '',
            }
        },
        beforeMount: function () {
            self = this;
            self.role.id = 0;
            self.checkLogin();
            //self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.getPermissions();
            self.getBuildVersion();
//            this.getBenefits();
            self.loadLocations();
            $('option[value="1"]').attr("selected", true);
        },

        watch: {
            /* locationId: function (locationId) {
                // console.log("Location Chaned");
                self.getBenefits();
            }, */
            locationType: function (locationType) {
                self.sliderType.location_type = locationType.value;
                /*console.log("Location Type Chaned");*/
                self.getBenefits();
            },
        },
        methods: {
            openModelFunction(id) {
                $('#' + id + '_myModal').modal("show");
            },
            loadLocations() {
                HTTP.post("getlocation")
                        .then(function (response) {
                            /*self.locationArr = response.data.content;*/
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    if (i == 1) {
                                        self.locationId = {
                                            value: response.data.content[i].value,
                                            text: response.data.content[i].text,
                                        };
                                    }
                                    self.locationArr.push(response.data.content[i]);
                                }
                            });
                            /*self.locationId = {
                             value: response.data.content[1].value,
                             text: response.data.content[1].text,
                             };*/
                            self.getBenefits();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },

            getBenefits: function () {
//                var params = {
//                    params : {
//                        location_id: self.locationId,
//                    }
//                }
                var fields = {location_id: /* self.locationId.value */ 0, location_type: self.locationType.value, };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post('getbenefits/' + self.locationId.value, fields, config).
                        then(response => {
                            if (response.data.content && response.data.content.length > 0 && self.locationType.value != response.data.content[0].location_type) {
                            // if (self.locationType.value != response.data.content[0].location_type) {
                                self.locationType = {'text': self.formatString(response.data.content[0].location_type), 'value': response.data.content[0].location_type};
                            }
                            self.benefitList = response.data.content;
                            self.video = response.data.video_url;
                            self.benefitGlance = response.data.benefit_glance;
                            self.sites = response.data.sites;
                            self.supports = response.data.supports;
                            self.communications = response.data.communications;
                            /*self.country = response.data.content[0].location_name;*/
                            self.country = response.data.selectedLocation.code;
                            /*self.sites = response.data.sites[0].site_url;*/
                            //console.log(self.sites);
                            /*switch (self.country) {
                             case "Arizona" :
                             self.country = "AZ"
                             break;
                             case "California" :
                             self.country = "CA";
                             break;
                             case "Nevada" :
                             self.country = "NV";
                             break;
                             }*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                    value = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return value;
            },
            mobilenumber(string, position, addstring) {
                if ($.trim(string) === "" && string.length <= 0) {
                    return string;
                } else {
                    return [string.slice(0, position), addstring, string.slice(position)].join('');
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Benefits.vue